import React, { useEffect, useState } from "react";
import {
  deleteAssetColumn,
  getAssetColumns,
  getAssetZohoLabels,
} from "../../service/api";
import { Button, Table } from "react-bootstrap";
import { FormTableRow } from "./Column";
import { showNotification } from "../../service/showNotification";
import styles from "./index.module.css";

const columns = [
  {
    field: "label",
    label: "Column name",
  },
  {
    field: "csvLabel",
    label: "Csv column name",
  },
  {
    field: "zohoLabel",
    label: "Zoho column name",
  },
  {
    field: "dataType",
    label: "Data type",
  },
  {
    field: "defaultValue",
    label: "Default value",
  },
  //   {
  //     field: "validation",
  //     label: "Validation",
  //   },
  {
    field: "isFormula",
    label: "Has formula",
  },
  {
    field: "formula",
    label: "Formula",
  },
  {
    field: "action",
    label: "Action",
  },
];

const AssetColumn = () => {
  const [rowsLoader, setRowsLoader] = useState(true);
  const [rows, setRows] = useState([]);
  const [zohoLabels, setZohoLabels] = useState([]);

  const handleAddNewRow = () => {
    const newRow = {
      _id: "new-" + Date.now(), // Temporary ID (do not remove)
      label: "",
      zohoLabel: "",
      csvLabel: [],
      dataType: "string",
      //   defaultValue: "",
      isFormula: false,
      formula: "",
      validation: {
        required: false,
        minLength: "",
        maxLength: "",
        min: "",
        max: "",
      },
      canDelete: true,
    };

    setRows((prevRows) => [newRow, ...prevRows]);
  };

  //fetch zoho labels
  const fetchAssetZohoLabels = async () => {
    try {
      const res = await getAssetZohoLabels();
      setZohoLabels(res?.data || []);
    } catch (err) {
      console.log("err", err);
      showNotification("error", "Failed to fetch asset csv labels.");
    }
  };

  const fetchColumns = async () => {
    try {
      const res = await getAssetColumns();
      setRows(res?.data || []);
    } catch (err) {
      console.log("err", err);
      showNotification("error", "Failed to fetch columns.");
    } finally {
      setRowsLoader(false);
    }
  };

  //delete column
  const onDelete = async (id) => {
    if (!id) {
      console.error("Column id not found");
      return;
    }

    const isOnlyState = id?.toLowerCase()?.includes("new-");

    // Optimistically remove the item from rows
    const prevRows = [...rows];
    const updatedRows = rows.filter((item) => item._id !== id);
    setRows(updatedRows);

    if (isOnlyState) return;

    try {
      // Call your delete API
      const res = await deleteAssetColumn(id);
      showNotification(
        "success",
        res?.message || "Column delete successfully."
      );
    } catch (err) {
      console.error("Failed to delete column:", err);
      showNotification(
        "err",
        err?.response?.data?.message || "Failed to delete column."
      );
      setRows(prevRows);
    }
  };

  useEffect(() => {
    fetchAssetZohoLabels();
    fetchColumns();
  }, []);

  return (
    <>
      <div className={styles.heading}>
        <Button variant="primary" onClick={handleAddNewRow}>
          Add New Column
        </Button>
      </div>
      <div style={{ overflow: "scroll" }}>
        <Table hover className="user-table align-items-center">
          <thead>
            <tr>
              {columns?.map((header, index) => (
                <th key={index}>{header?.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rowsLoader ? (
              <tr>
                <td className={styles.center} colSpan={columns.length}>
                  Loading...
                </td>
              </tr>
            ) : !rows.length ? (
              <tr>
                <td className={styles.center} colSpan={columns.length}>
                  No Records Found.
                </td>
              </tr>
            ) : (
              rows?.map((row) => (
                <FormTableRow
                  key={row._id}
                  rowData={row}
                  zohoLabels={zohoLabels}
                  columns={rows}
                  onDelete={onDelete}
                  fetchColumns={fetchColumns}
                />
              ))
            )}
          </tbody>
        </Table>
      </div>
    </>
  );
};

export default AssetColumn;
